import { FormattedMessage } from 'react-intl'
import Text from 'components/shared/Text'
import Info from 'components/shared/Info'
import { BirthdayPromotionContentWrapper } from './styles'
import { darkMode } from 'styles/theme'
import { BIRTHDAY_PROMOTION_REGULATIONS_LINK } from 'constants/links'
import { Spacing } from 'styles/spacing'
import Link from 'components/shared/Link'
import { useState } from 'react'
import BirthdayPromotionModal from 'components/global/promotions/BirthdayPromotion/BirthdayPromotionModal'

type BlackWeekendTicketsInitialInfoProps = Spacing

const BirthdayPromotionContent = ({
    ...args
}: BlackWeekendTicketsInitialInfoProps) => {
    const [isPricingModalOpened, setIsPricingModalOpened] = useState(false)

    const handlePricingModalVisibility = (isOpened: boolean) =>
        setIsPricingModalOpened(isOpened)

    const PromoMaxDiscoutInfo = (
        <Text variant="bodySmall" color="grayscale_400">
            <FormattedMessage
                id="promo.birthday.creator_promo_max_discount_info"
                defaultMessage="Świętuj z nami! Bilety <span>nawet do 55% taniej</span> z okazji 5 urodzin Parku! Promocja ważna do 26.02.2025. <break></break><button>Sprawdź wysokość zniżek</button> na każdy miesiąc. <link>Regulamin promocji</link>"
                description="Keep the html tags in the translation"
                values={{
                    span: (chunks: string[]) => (
                        <>
                            <Text
                                as="span"
                                variant="bodySmallStrong"
                                color="grayscale_300"
                            >
                                {chunks}
                            </Text>
                        </>
                    ),
                    button: (chunks: string[]) => (
                        <>
                            <Link
                                icon={null}
                                variant="primary"
                                textVariant="bodySmall"
                                isUnderlined
                                onClick={() =>
                                    handlePricingModalVisibility(true)
                                }
                            >
                                {chunks}
                            </Link>
                        </>
                    ),
                    link: (chunks: string[]) => (
                        <Text
                            as="a"
                            href={BIRTHDAY_PROMOTION_REGULATIONS_LINK}
                            target="_blank"
                            variant="bodySmall"
                            isUnderlined
                            color="grayscale_400"
                        >
                            {chunks}
                        </Text>
                    ),
                    break: (chunks: string[]) => <br />,
                }}
            />
        </Text>
    )

    return (
        <BirthdayPromotionContentWrapper isFullWidth {...args}>
            <Info
                variantType="party"
                color="info"
                hasNoBackground
                hasBorder
                theme={darkMode}
            >
                {PromoMaxDiscoutInfo}
            </Info>
            <BirthdayPromotionModal
                isOpened={isPricingModalOpened}
                close={() => handlePricingModalVisibility(false)}
            />
        </BirthdayPromotionContentWrapper>
    )
}

export default BirthdayPromotionContent
